import React from 'react';

export default function UtilNotFound() {
    return <div>Not Found</div>;
}
